import React from 'react';

import IconType from '../../../types/Icon';

const ArrowDownIcon: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M6 9L12 15L18 9" stroke={color} strokeWidth="2" />
		</svg>
	);
};

export default ArrowDownIcon;
